import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const curRB = state => state.models[name].data;
export const curRBs = state => state.models[name].list;
export const isRBLoading = state => state.models[name].loading;
